module.exports = __webpack_public_path__ + "static/media/ejemplo_roles_genero.71061f26.jpg";